import { Injectable } from '@angular/core';
import { RootService } from '@app/core/root.service';
import { ItemProps } from '@app/interfaces';
import { Router } from '@angular/router';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { Validators } from '@angular/forms';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { CustomValidators } from '@app/core/classes/custom-validators/custom-validators';
import { SharedService } from '@app/shared/services/shared.service';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { Observable } from 'rxjs';
import { UsersService } from '@app/users-feature/users.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends RootService {
  constructor(
    router: Router,
    api: ApiRequestService,
    shared: SharedService,
    permissionsService: PermissionsService,
    private toArabicPipe: ToArabicPipe,
    private usersService: UsersService
  ) {
    super(router, api, permissionsService, shared);
  }

  getFunctionURL(action: any, suffix: string = '', prefix: string = 'users/') {
    return action ? prefix + this.routerPrefix() + '/' + action + suffix : prefix + this.routerPrefix() + suffix;
  }

  routerPrefix(val: string = '') {
    return val ? val : 'profile';
  }

  refactorItem(item: any) {
    return item;
  }
  navigateToList() {
    this.usersService.updateResources.next(null);
    return super.navigateToList();
  }

  // updateItem(id: any, data: {}): any  {
  // super.updateItem(id, data);
  // this.shared.updateProfile$.next(null);
  // console.log('profile updated succussfully');
  // }

  refactorFormBeforeSubmit(formValue: any) {
    if (formValue.changePassword) {
      delete formValue.changePassword;
    }
    if (formValue.old_password === null) {
      delete formValue.old_password;
    }
    if (formValue.password === null) {
      delete formValue.password;
    }
    if (formValue.changePassword === null) {
      delete formValue.changePassword;
    }
    if (formValue.password_confirmation === null) {
      delete formValue.password_confirmation;
    }
    if (typeof formValue.avatar === 'string' && formValue.avatar !== '') {
      delete formValue.avatar;
    }
    return formValue;
  }

  get featureProps(): ItemProps[] {
    return [
      {
        name: 'avatar',
        prop: 'avatar',
        form: {
          inputValueType: 'formData',
          formFieldType: 'img',
          placeHolder: 'assets/images/icons/user-placeholder.svg',
          Validators: []
        }
      },
      {
        name: 'full_name',
        prop: 'full_name',
        form: {
          disabled: true,
          Validators: [],
          formFieldType: 'text'
        }
      },
      {
        name: 'email',
        prop: 'email',
        form: {
          disabled: true,
          Validators: [],
          formFieldType: 'email'
        }
      },
      {
        name: 'phone',
        prop: 'phone',
        form: {
          Validators: [CustomValidators.mobileNumber],
          formFieldType: 'text_number',
          maxLength: 10,
          minLength: 10
        }
      },
      {
        name: 'changePassword',
        prop: 'changePassword',
        form: {
          Validators: [],
          formFieldType: 'button_as_checkbox',
          cssClass: 'mrg-btm-15em'
        }
      },
      {
        name: 'old_password',
        prop: 'old_password',
        form: {
          editDisabled: true,
          Validators: [
            // 1. Password Field is Required
            Validators.required
            // 2. check whether the entered password has a number
            // CustomValidators.patternValidator(/\d/, { hasNumber: true }),
            // // 3. check whether the entered password has upper case letter
            // CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
            // // 4. check whether the entered password has a lower-case letter
            // CustomValidators.patternValidator(/[a-z]/, { hasSmallCase: true }),
            // // 5. check whether the entered password has a special character
            // CustomValidators.patternValidator(/[!@#$%^&*(),.?":{}|<>]/, { hasSpecialCharacters: true }),
            // // 6. Has a minimum length of 8 characters
            // Validators.minLength(8)
          ],
          formFieldType: 'password',
          showConditions: [
            {
              fnProp: {
                prop: 'changePassword',
                fn: prop => {
                  return !!prop;
                }
              }
            }
          ]
        }
      },
      {
        name: 'password',
        prop: 'password',
        form: {
          editDisabled: true,
          Validators: [
            // 1. Password Field is Required
            Validators.required,
            // 2. check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, { hasNumber: true }),
            // 3. check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
            // 4. check whether the entered password has a lower-case letter
            CustomValidators.patternValidator(/[a-z]/, { hasSmallCase: true }),
            // 5. check whether the entered password has a special character
            CustomValidators.patternValidator(/[&\-_.!@#$%*?+~]/, { hasSpecialCharacters: true }),
            // 6. Has a minimum length of 8 characters
            Validators.minLength(8)
          ],
          formFieldType: 'password',
          showConditions: [
            {
              fnProp: {
                prop: 'changePassword',
                fn: prop => {
                  return !!prop;
                }
              }
            }
          ]
        },
        hints: {
          password_helper: true,
          minLength: 8,
          hasSpecialCharacters: '&-_.!@#$%*?+~',
          hasCapitalCase: true,
          hasSmallCase: true,
          hasNumber: true
        }
      },
      {
        name: 'password_confirmation',
        prop: 'password_confirmation',
        form: {
          Validators: null,
          formFieldType: 'confirmPassword',
          showConditions: [
            {
              fnProp: {
                prop: 'changePassword',
                fn: prop => {
                  return !!prop;
                }
              }
            }
          ]
        },
        hints: {
          password_helper: true
        }
      }
    ];
  }
}
